import {ENDPOINT_URL} from '../constants/index';
import {apiErrorHandling} from '../utils/apiUtils';

import getFetchOptions from '../utils/getFetchOptions';

export default function deleteAllTestsPermanently(allTestKeys) {
	return fetch(
		`${ENDPOINT_URL}/tests/permanentdelete`,
		getFetchOptions({
			method: 'DELETE',
			body: JSON.stringify({
				allTestKeys,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
